"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pluralizeYears = exports.pluralizeTours = exports.pluralizeTouristsCount = exports.pluralizeTouristsAcc = exports.pluralizeTourists = exports.pluralizeReviews = exports.pluralizePoints = exports.pluralizePerson = exports.pluralizeOptions = exports.pluralizeOperators = exports.pluralizeOffers = exports.pluralizeNights = exports.pluralizeMinutesGen = exports.pluralizeLuggage = exports.pluralizeKids = exports.pluralizeHoursGen = exports.pluralizeHotels = exports.pluralizeFlights = exports.pluralizeDays = exports.pluralizeBySubject = exports.pluralizeAdults = void 0;
var _userflow = require("./userflow");
var _userflow2 = require("../constants/userflow");
var PLURAL = {
  YEARS: ['год', 'года', 'лет'],
  DAYS: ['день', 'дня', 'дней'],
  KIDS: ['ребёнок', 'ребёнка', 'детей'],
  ADULTS: ['взрослый', 'взрослых', 'взрослых'],
  NIGHTS: ['ночь', 'ночи', 'ночей'],
  TOURS: ['тур', 'тура', 'туров'],
  OFFERS: ['предложение', 'предложения', 'предложений'],
  FLIGHTS: ['рейс', 'рейса', 'рейсов'],
  OPTIONS: ['вариант', 'варианта', 'вариантов'],
  REVIEWS: ['отзыв', 'отзыва', 'отзывов'],
  POINTS: ['очко', 'очка', 'очков'],
  TOURISTS: ['турист', 'туриста', 'туристов'],
  TOURISTS_ACC: ['туриста', 'туристов', 'туристов'],
  HOURS_GEN: ['часе', 'часах', 'часах'],
  MINUTES_GEN: ['минуте', 'минутах', 'минутах'],
  LUGGAGE: ['место', 'места', 'мест'],
  PERSON: ['человек', 'человека', 'человек'],
  OPERATORS: ['туроператор', 'туроператора', 'туроператоров'],
  HOTELS: ['отель', 'отеля', 'отелей']
};
var pluralizeYears = exports.pluralizeYears = function pluralizeYears(value) {
  return (0, _userflow.pluralize)(value, PLURAL.YEARS);
};
var pluralizeDays = exports.pluralizeDays = function pluralizeDays(value) {
  return (0, _userflow.pluralize)(value, PLURAL.DAYS);
};
var pluralizeKids = exports.pluralizeKids = function pluralizeKids(value) {
  return (0, _userflow.pluralize)(value, PLURAL.KIDS);
};
var pluralizeAdults = exports.pluralizeAdults = function pluralizeAdults(value) {
  return (0, _userflow.pluralize)(value, PLURAL.ADULTS);
};
var pluralizeNights = exports.pluralizeNights = function pluralizeNights(value) {
  return (0, _userflow.pluralize)(value, PLURAL.NIGHTS);
};
var pluralizeTours = exports.pluralizeTours = function pluralizeTours(value) {
  return (0, _userflow.pluralize)(value, PLURAL.TOURS);
};
var pluralizeOffers = exports.pluralizeOffers = function pluralizeOffers(value) {
  return (0, _userflow.pluralize)(value, PLURAL.OFFERS);
};
var pluralizeFlights = exports.pluralizeFlights = function pluralizeFlights(value) {
  return (0, _userflow.pluralize)(value, PLURAL.FLIGHTS);
};
var pluralizeOptions = exports.pluralizeOptions = function pluralizeOptions(value) {
  return (0, _userflow.pluralize)(value, PLURAL.OPTIONS);
};
var pluralizeReviews = exports.pluralizeReviews = function pluralizeReviews(value) {
  return (0, _userflow.pluralize)(value, PLURAL.REVIEWS);
};
var pluralizePoints = exports.pluralizePoints = function pluralizePoints(value) {
  return (0, _userflow.pluralize)(value, PLURAL.POINTS);
};
var pluralizeTouristsCount = exports.pluralizeTouristsCount = function pluralizeTouristsCount(value) {
  return value === 1 ? "".concat(value).concat(_userflow2.NDASHS, "\u0433\u043E") : "".concat(value).concat(_userflow2.NDASHS, "\u0445");
};
var pluralizeTourists = exports.pluralizeTourists = function pluralizeTourists(value) {
  return (0, _userflow.pluralize)(value, PLURAL.TOURISTS);
};
var pluralizeTouristsAcc = exports.pluralizeTouristsAcc = function pluralizeTouristsAcc(value) {
  return (0, _userflow.pluralize)(value, PLURAL.TOURISTS_ACC);
};
var pluralizeHoursGen = exports.pluralizeHoursGen = function pluralizeHoursGen(value) {
  return (0, _userflow.pluralize)(value, PLURAL.HOURS_GEN);
};
var pluralizeMinutesGen = exports.pluralizeMinutesGen = function pluralizeMinutesGen(value) {
  return (0, _userflow.pluralize)(value, PLURAL.MINUTES_GEN);
};
var pluralizeLuggage = exports.pluralizeLuggage = function pluralizeLuggage(value) {
  return (0, _userflow.pluralize)(value, PLURAL.LUGGAGE);
};
var pluralizePerson = exports.pluralizePerson = function pluralizePerson(value) {
  return (0, _userflow.pluralize)(value, PLURAL.PERSON);
};
var pluralizeOperators = exports.pluralizeOperators = function pluralizeOperators(value) {
  return (0, _userflow.pluralize)(value, PLURAL.OPERATORS);
};
var pluralizeHotels = exports.pluralizeHotels = function pluralizeHotels(value) {
  return (0, _userflow.pluralize)(value, PLURAL.HOTELS);
};
var pluralizeBySubject = exports.pluralizeBySubject = function pluralizeBySubject(value, subject) {
  return (0, _userflow.pluralize)(value, PLURAL[subject]);
};